const baseUrl = process.env.VUE_APP_BACKEND_ROUTE;

export function objectToGETParams(obj, parentKey) {
    let query = [];
    Object.keys(obj).forEach(k => {
        if (null === obj[k] || undefined === obj[k]) {
            return;
        }
        if (obj[k] instanceof Array) {
            if (obj[k].length > 0) {
                let q = []
                let key = parentKey ? parentKey + '[' + k + ']' : k;
                obj[k].forEach((v) => {
                    if (null === v || undefined === v) {
                        return;
                    }
                    if ('object' === typeof v) {
                        let nested = objectToGETParams(v, key);
                        if (nested) {
                            q.push(nested);
                        }
                    } else {
                        q.push(key + '[]=' + encodeURIComponent(v));
                    }
                });
                if (q.length > 0) {
                    query.push(q.join('&'))
                }
            }
        } else if (obj[k] instanceof Object) {
            let nested = objectToGETParams(obj[k], parentKey ? parentKey + '[' + k + ']' : k);
            if (nested) {
                query.push(nested);
            }
        } else {
            if (parentKey) {
                query.push(parentKey + '[' + k + ']' + '=' + encodeURIComponent(obj[k]));
            } else {
                query.push(k + '=' + encodeURIComponent(obj[k]));
            }
        }
    });
    return query.join('&');
}

//  todo refactor this shit!!!
export default {
    getBaseUrl() {
        return baseUrl;
    },
    echa: {
        getS2SKey(organizationId) {
            return baseUrl + '/echa/s2s/key/' + organizationId;
        },
        saveS2SKey(organizationId) {
            return baseUrl + '/echa/s2s/key/' + organizationId;
        }
    },
    pages: {
        categories(config) {
            return baseUrl + '/pages/categories?' + objectToGETParams(config);
        },
        createCategory() {
            return baseUrl + '/pages/categories';
        },
        updateCategory(id) {
            return baseUrl + '/pages/categories/' + id;
        },
        getCategory(id) {
            return baseUrl + '/pages/categories/' + id;
        },
        deleteCategory(id) {
            return baseUrl + '/pages/categories/' + id;
        },

        news(config) {
            return baseUrl + '/pages/news?' + objectToGETParams(config);
        },
        createNews() {
            return baseUrl + '/pages/news';
        },
        updateNews(id) {
            return baseUrl + '/pages/news/' + id;
        },
        getNews(id) {
            return baseUrl + '/pages/news/' + id;
        },
        deleteNews(id) {
            return baseUrl + '/pages/news/' + id;
        },
        featuredNews() {
            return baseUrl + '/pages/news/featured';
        },

        getParsedSystemContent(key) {
            return baseUrl + '/pages/system-content/parsed/' + key;
        },
        getSystemContent(id) {
            return baseUrl + '/pages/system-content/' + id;
        },
        systemContent(config) {
            return baseUrl + '/pages/system-content?' + objectToGETParams(config);
        },
        updateSystemContent(id) {
            return baseUrl + '/pages/system-content/' + id;
        },
    },

    i18n: {
        translations(locale) {
            return baseUrl + '/i18n/messages/' + locale;
        },

        grid() {
            return baseUrl + '/i18n/grid';
        },

        gridTranslations(key) {
            return baseUrl + '/i18n/grid/translations/' + key;
        },

        saveTranslations(key) {
            return baseUrl + '/i18n/grid/translations';
        },

        switchLanguage() {
            return baseUrl + '/i18n/switch-language';
        }
    },

    system: {
        services: {
            grid() {
                return baseUrl + '/system/services';
            },
            hierarchy() {
                return baseUrl + '/system/services';
            },
            card(id) {
                return baseUrl + '/system/services/' + id;
            },
            userInterfaces(id) {
                return baseUrl + '/system/services/' + id + '/user-interfaces';
            },
            create() {
                return baseUrl + '/system/services';
            }
        },

        scheduler: {
            tasks(config) {
                const query = config ? objectToGETParams(config) : '';
                return baseUrl + '/system/scheduler/tasks' + (query ? '?' + query : '');
            },
            task(id) {
                return baseUrl + '/system/scheduler/tasks/' + id;
            },
            cancelTask(id) {
                return baseUrl + '/system/scheduler/tasks/' + id + '/cancel';
            },
            rescheduleTask(id) {
                return baseUrl + '/system/scheduler/tasks/' + id + '/reschedule';
            }
        },

        security: {
            operations() {
                return baseUrl + '/system/security/operations';
            },
            userInterfaces(config) {
                return baseUrl + '/system/security/user-interfaces?' + objectToGETParams(config);
            },
            addUserInterface() {
                return baseUrl + '/system/security/user-interfaces';
            }
        },

        email: {
            validateSmtp() {
                return baseUrl + '/system/email/validate-smtp';
            },
            validateConfiguration(id) {
                return baseUrl + '/system/email/configuration/validate/' + id;
            },
            searchConfiguration(criteria) {
                return baseUrl + '/system/email/search-configuration?' + objectToGETParams(criteria);
            },
            getConfiguration(id) {
                return baseUrl + '/system/email/configuration/' + id;
            },
            getConfigurations() {
                return baseUrl + '/system/email/configuration';
            },
            resendRequestEmail(id) {
                return baseUrl + '/system/email/resend/product-request';
            },
            sendInvitation() {
                return baseUrl + '/system/email/invitation/send';
            },
            getProviders() {
                return baseUrl + '/system/email/providers';
            },
            resolveEmailProvider() {
                return baseUrl + '/system/email/resolve-provider';
            },
            getResolveEmailProviderState(id) {
                return baseUrl + '/system/email/resolve-provider/' + id + '/status';
            }
        }
    },

    subscriber: {
        list(config) {
            return baseUrl + '/subscribers?' + objectToGETParams(config);
        },

        get(id) {
            return baseUrl + '/subscribers/' + id;
        },

        update(id) {
            return baseUrl + '/subscribers/' + id;
        },

        create() {
            return baseUrl + '/subscribers';
        }
    },

    supplyChain: {
        businessRoles() {
            return baseUrl + '/supply-chain/business-roles';
        },
        states() {
            return baseUrl + '/supply-chain/states';
        },
        newSupplier() {
            return baseUrl + '/supply-chain/suppliers';
        },
        updateSupplier(id) {
            return baseUrl + '/supply-chain/suppliers/' + id;
        },
        newInternalOrganization() {
            return baseUrl + '/supply-chain/internal-organizations';
        },
        updateInternalOrganization(id) {
            return baseUrl + '/supply-chain/internal-organizations/' + id;
        },
        searchSupplier(qs) {
            return baseUrl + '/supply-chain/suppliers/search/' + qs;
        },
        getSuppliers(config) {
            return baseUrl + '/supply-chain/grid/supplier?' + objectToGETParams(config);
        },
        searchCustomers(qs) {
            return baseUrl + '/supply-chain/customers/search/' + qs;
        },
        getCustomers(config) {
            return baseUrl + '/supply-chain/grid/customer?' + objectToGETParams(config);
        },
        getInternalOrganizations(config) {
            return baseUrl + '/supply-chain/grid/internal?' + objectToGETParams(config);
        },
        organization(id) {
            return baseUrl + '/supply-chain/organizations/' + id;
        },
        organizations(hierarchy, type) {
            let object = {
                hierarchy: hierarchy ? 1 : 0
            };
            if (type) {
                object.type = type;
            }
            return baseUrl + '/supply-chain/organizations?' + objectToGETParams(object);
        },
        allSuppliers() {
            return baseUrl + '/supply-chain/suppliers';
        }
    },

    product: {
        attributes() {
            return baseUrl + '/product/attributes';
        },
        category(id) {
            return baseUrl + '/product/category/' + id;
        },
        categories() {
            return baseUrl + '/product/categories';
        },
        categoryChildren(id) {
            return baseUrl + '/product/category/' + id + '/children';
        },

        searchPurchasedProducts(supplierId, qs) {
            return baseUrl + '/product/search/supplier/' + supplierId + '/' + qs;
        },

        searchIncludedProducts(qs) {
            return baseUrl + '/product/search/included/' + qs;
        },

        searchProducts(query, limit = 15) {
            const params = objectToGETParams({ query, limit });
            return baseUrl + '/product/search' + (params ? '?' + params : '');
        },

        productSummaries() {
            return baseUrl + '/product/summaries';
        },

        compositionRoots(config) {
            return baseUrl + '/product/composition-roots?' + objectToGETParams(config);
        },

        overview(config) {
            return baseUrl + '/product/overview?' + objectToGETParams(config);
        },
        overviewFilter(filters, page, perPage) {
            const options = [
                objectToGETParams({page, perPage}),
                objectToGETParams(filters)
            ];
            return baseUrl + '/product/overview/filter?' + options.filter(o => o).join('&');
        },
        add() {
            return baseUrl + '/product';
        },

        update(id) {
            return baseUrl + '/product/' + id;
        },

        substanceListQuestion(productId, listId) {
            return baseUrl + '/product/' + productId + '/substance-list-questions/' + listId;
        },

        identifiers(productId) {
            return baseUrl + '/product/' + productId + '/identifiers';
        },

        updateScipSettings(id) {
            return baseUrl + '/product/' + id + '/scip-notification/settings';
        },

        excludeFromScipNotification(id) {
            return baseUrl + '/product/' + id + '/scip-notification/exclude';
        },
        unsetExclusionFromScipNotification(id, product, parent) {
            return baseUrl + '/product/' + id + '/scip-notification/unset-exclusion/' + parent + '/' + product;
        },

        hierarchy(id) {
            return baseUrl + '/product/' + id + '/hierarchy';
        },

        getSentRequests(config) {
            return baseUrl + '/product/sent/requests?' + objectToGETParams(config);
        },

        getSentRequest(id) {
            return baseUrl + '/product/sent/requests/' + id;
        },

        getReply(id) {
            return baseUrl + '/product/sent/requests/' + id + '/reply';
        },

        approveRequest(id) {
            return baseUrl + '/product/sent/requests/approve';
        },

        rejectRequest(id) {
            return baseUrl + '/product/sent/requests/' + id + '/reject';
        },

        getCustomerRequestSentRequests(id) {
            return baseUrl + '/product/customer/requests/' + id + '/sent-requests';
        },

        getCustomerRequest(id) {
            return baseUrl + '/product/customer/requests/' + id;
        },

        getBulkReplyCandidates(id) {
            return baseUrl + '/product/customer/requests/' + id + '/bulk-reply-candidates';
        },

        updateCustomerRequest(id) {
            return baseUrl + '/product/customer/requests/' + id;
        },

        getCustomerRequests(config) {
            return baseUrl + '/product/customer/requests?' + objectToGETParams(config);
        },

        getSubmissions(config) {
            return baseUrl + '/submissions?' + objectToGETParams(config);
        },

        getSubmissionCard(id) {
            return baseUrl + '/submissions/' + id;
        },

        saveSubstances(id) {
            return baseUrl + '/product/' + id + '/substances';
        },

        saveDocuments(id) {
            return baseUrl + '/product/' + id + '/documents';
        },

        organizationDocuments(id) {
            return baseUrl + '/product/' + id + '/documents/organization';
        },

        organizationUnclassifiedDocuments(id) {
            return baseUrl + '/product/' + id + '/documents/organization/unclassified';
        },

        supplierVerificationDocuments(id) {
            return baseUrl + '/product/' + id + '/documents/supplier';
        },

        supplierVerificationReplyDocuments(id) {
            return baseUrl + '/product/' + id + '/verification-documents/supplier/reply';
        },

        supplierUnclassifiedVerificationDocuments(id) {
            return baseUrl + '/product/' + id + '/documents/supplier/unclassified';
        },

        unclassifiedVerificationDocuments(id) {
            return baseUrl + '/product/' + id + '/documents/unclassified-verification';
        },

        receivedRequestDocuments(id) {
            return baseUrl + '/product/received/requests/' + id + '/documents';
        },

        receivedRequestUnclassifiedVerificationDocuments(id) {
            return baseUrl + '/product/received/requests/' + id + '/documents/unclassified-verification';
        },

        receivedRequestDocumentationLinks(id) {
            return baseUrl + '/product/received/requests/' + id + '/documentation-links';
        },

        receivedRequestForwardedRequests(id) {
            return baseUrl + '/product/received/requests/' + id + '/forwarded-requests';
        },

        receivedRequestWorkflowState(id) {
            return baseUrl + '/product/received/requests/' + id + '/workflow-state';
        },

        deleteDocument(pid, id) {
            return baseUrl + '/product/' + pid + '/documents/' + id;
        },

        downloadDocument(pid, id) {
            return baseUrl + '/product/' + pid + '/documents/' + id + '/download';
        },

        getDocuments(id) {
            return baseUrl + '/product/' + id + '/documents';
        },

        sendRequest(id) {
            return baseUrl + '/product/' + id + '/requests';
        },

        forwardRequest(id) {
            return baseUrl + '/product/customer/requests/' + id + '/forward';
        },

        replyRequest(id) {
            return baseUrl + '/product/customer/requests/' + id + '/reply';
        },

        replyRequestBulk(id) {
            return baseUrl + '/product/customer/requests/' + id + '/reply/bulk';
        },

        convertToPurchasedProduct(id) {
            return baseUrl + '/product/' + id + '/convert-to-purchased';
        },

        getSubstances(id) {
            return baseUrl + '/product/' + id + '/substances';
        },

        getConcernElements(id) {
            return baseUrl + '/product/' + id + '/concern-elements';
        },

        groups() {
            return baseUrl + '/product/groups';
        },
        card(id) {
            return baseUrl + '/product/' + id + '/card';
        },
        makeSubmission(id) {
            return baseUrl + '/product/' + id + '/submission';
        },
        remove(id) {
            return baseUrl + '/product/' + id + '/card';
        },

        product(id) {
            return baseUrl + '/product/' + id;
        },

        scipNotificationFacts(id) {
            return baseUrl + '/product/' + id + '/scip-notification/facts';
        },

        scipNotificationPreview(id) {
            return baseUrl + '/product/' + id + '/scip-notification/preview';
        },

        legislationStatusExplanation(id, legislationId) {
            return baseUrl + '/product/' + id + '/legislations/' + legislationId + '/status-explanation';
        },

        legislationQuestionAnswers(id) {
            return baseUrl + '/product/' + id + '/legislation/question-answers';
        },

        componentsToRequest(id) {
            return baseUrl + '/product/' + id + '/request/components';
        },

        includeComponents(id) {
            return baseUrl + '/product/' + id + '/components';
        },

        updateComponent(id, cid) {
            return baseUrl + '/product/' + id + '/components/' + cid;
        },

        convertType(id) {
            return baseUrl + '/product/' + id + '/convert';
        },

        excludeComponent(id, componentId) {
            return baseUrl + '/product/' + id + '/components/' + componentId;
        },

        componentsSubstances(id, legislations) {
            legislations = legislations ? '?' + objectToGETParams({legislations}) : '';
            return baseUrl + '/product/' + id + '/components/substances' + legislations;
        },

        complexComposition(id, include = []) {
            const query = include.length > 0 ? '?' + objectToGETParams({include}) : '';
            return baseUrl + '/product/' + id + '/composition/complex' + query;
        },

        additionalMaterials() {
            return baseUrl + '/product/additional-materials';
        },

        mixtureCategories() {
            return baseUrl + '/product/mixture-categories';
        },
        sendProductRequestEmail(productId) {
            return baseUrl + '/product/send-request-email';
        },
        sendApproveDeclarationMessage(productRequestId) {
            return baseUrl + '/product/customer/requests/' + productRequestId + '/approve-declaration/otp';
        },
        approveDeclaration(productRequestId) {
            return baseUrl + '/product/customer/requests/' + productRequestId + '/approve-declaration/approve';
        }
    },

    legislation: {
        all() {
            return baseUrl + '/legislations';
        },

        get(config) {
            return baseUrl + '/legislations?' + objectToGETParams(config);
        },

        getEvidenceReportTypes() {
            return baseUrl + '/legislations/evidence-report-types';
        },

        getVerificationDocumentTypes() {
            return baseUrl + '/legislations/verification-document-types';
        },

        legislationStatuses(id) {
            return baseUrl + '/legislations/' + id + '/statuses';
        },
        card(id) {
            return baseUrl + '/legislations/' + id;
        },
        questionGroups(config) {
            const query = objectToGETParams(config || {});

            return baseUrl + '/legislation-question-groups' + (query ? '?' + query : '');
        },
        questionGroup(id) {
            return baseUrl + '/legislation-question-groups/' + id;
        },
        questionCatalog(config) {
            const query = objectToGETParams(config || {});

            return baseUrl + '/legislation-question-catalog' + (query ? '?' + query : '');
        },
        questionnaire(config) {
            const query = objectToGETParams(config || {})

            return baseUrl + '/legislation-questionnaire' + (query ? '?' + query : '')
        },
    },

    substances: {
        lists() {
            return baseUrl + '/substance/lists';
        },

        listSubstances(listId) {
            return baseUrl + '/substance/list/' + listId + '/substances';
        },

        listSubstancesInclusion(listId) {
            return baseUrl + '/substance/list/' + listId + '/substances/inclusion';
        },

        materialCategories() {
            return baseUrl + '/substance/material-categories';
        },

        search(qs, context = {}) {
            const query = objectToGETParams(context);

            return baseUrl + '/substance/search/' + qs + (query ? '?' + query : '');
        },

        summary(ids) {
            const query = objectToGETParams({ ids });
            return baseUrl + '/substances/summary' + (query ? '?' + query : '');
        },

        regulationsResolution() {
            return baseUrl + '/substances/regulations/resolve';
        }
    },

    messenger: {
        getChatByRequestId(id) {
            return baseUrl + '/messenger/conversation/request/' + id;
        },

        sendMessage(id) {
            return baseUrl + '/messenger/conversation/' + id;
        },

        unreadMessages(id, offset) {
            return baseUrl + '/messenger/conversation/' + id + '/unread/' + offset;
        }
    },

    user: {

        login() {
            return baseUrl + '/login_check';
        },

        refreshToken() {
            return baseUrl + '/token/refresh';
        },

        resetPassword() {
          return baseUrl + '/user/reset-password';
        },

        swiftLogin() {
            return baseUrl + '/user/swift-login';
        },

        organizationSelect() {
            return baseUrl + '/user/organization/select';
        },

        profile() {
            return baseUrl + '/user/profile';
        },

        getUsers(config) {
            return baseUrl + '/users?' + objectToGETParams(config);
        },

        card(id) {
            if (!id) {
                return baseUrl + '/user';
            }
            return baseUrl + '/user/' + id;
        },

        roles() {
            return baseUrl + '/user/roles';
        },

        mfaCodeRequest() {
            return baseUrl + '/user/mfa/code/request';
        },

        mfaCodeVerify() {
            return baseUrl + '/user/mfa/code/verify';
        },

        systemRoles(id) {
            if (!id) {
                return baseUrl + '/user/system/roles';
            }

            return baseUrl + '/user/system/roles/' + id;
        },

        systemRoleCapabilities() {
            return baseUrl + '/user/system/role-capabilities';
        },

        updateEmailPreferences() {
            return baseUrl + '/user/settings/email-preferences'
        },

        updateSettings() {
            return baseUrl + '/user/settings'
        }
    },

    import: {
        candidateList() {
            return baseUrl + '/import/candidate-list';
        }
    }
};
